import { Component, OnInit,  } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable'

import { User } from '../../models/user.model';
import { ClientsService } from '../services/clients.service';
import { Client } from '../models/client.model';
import { AuthService } from '../services/auth.service';
import { AddressesService } from '../services/addresses.service';

@Component({
  selector: 'app-select-client',
  templateUrl: './select-client.component.html',
  styleUrls: ['./select-client.component.css']
})
export class SelectClientComponent implements OnInit {
  isLoggedIn$: Observable<boolean>
  clients: Client[];
  client: Client  = {cname: 'No Client Selected', address: "", city: "", state: "", zip: "", qbid: "0"};

  user;
  displayButton:boolean;
  clientContacts;
  addClientContact = false;
  phone;
  clientName;
  clientId;
  altAddresses;
  altContacts;
  dragging = false;
  draggingContact = false;
  openAddressAddForm = false;
  altAddressId;

  constructor(private clientsService: ClientsService,
              private addressesService: AddressesService,
              private router: Router, private authService: AuthService) {
      this.onNoClient();
      this.authService.getUserClientPromise2()
      .then(() => {
        this.authService.user$.subscribe((user:any) => {
          this.isLoggedIn$ = this.authService.isLoggedIn$;
          this.user = user;
          if(!user.message && user.clientid > 0) {
            this.displayButton = false;
          }else if(!user.message && user.clientid == 0) {
            this.getClients()
          }
          this.authService.client$.subscribe((client) => {
            this.clientName = client.cname;
            this.clientId = client.clientid;
            this.client = client;
          })
        });
        this.  getClientStored();


      });
   }

  ngOnInit() {
  };

  onMouseCursorEnter(event) {
    event.target.classList.add('crosshair');
  }

  onMouseCursorExit(event) {
    event.target.classList.remove('crosshair');
  }

  getAltAddresses(clientid){
    if(clientid != 0){
      this.addressesService.getAltAddresses(clientid)
      .then( addresses => {
        this.altAddresses = addresses;
        // this.onPickupSelected(this.user.defaultpickupid)
      });
    }
  }


  onDrop(event) {
    // client contact darg and drop event
    const contactid = event.dataTransfer.getData('text/plain');
    this.dragging = false;
    this.reOrderClientContacts(contactid, () => {
      // now loop through client contacts and update each clientcontact
       this.clientContacts.forEach( (contact) =>  {
        this.addressesService.updateClientContact(contact)
        .then( (result) => {
          this.getClientContacts(this.clientId)
        } );
       });

    });
  }

  reOrderClientContacts(contactid, callback) {
    // 1slice the array to remove dragged  li by contact id
    let removed;

    for (let i =0 ; i < this.clientContacts.length; i++) {
      if (this.clientContacts[i].contactid == contactid) {
          removed = this.clientContacts.splice(i, 1 );
          // Now change update sortorder setting removed[0] to 0 the rest to 1
          this.clientContacts.forEach( (contact) => {
            contact.sortorder = 1;
          });

          removed[0].sortorder = 0;
          this.clientContacts.unshift(removed[0]);

          callback();
      }
    }
  }

  allowDrop(event) {
    // console.log(event)
  }

  onDragStart(event) {
    this.dragging = true;
    event.dataTransfer.setData( 'text/plain', event.target.id);
    event.dataTransfer.effectAllowed = 'move';
  }

  onDragEnter(event) {
    event.preventDefault();

  }

  onDragOver(event) {
    event.preventDefault();
  }

  getClientStored() {
    // get the client from stored
    if (localStorage.getItem('selectedId')) {
      this.clientsService.getSelectedClient(localStorage.getItem('selectedId'))
      .then(client => {
        this.client = client[0];
        this.getAltAddresses(this.client.clientid);
      });
    }
  }

  getClients(){
    // get the client list from clients.service
    this.clientsService.getClients()
    .then(response => {
      if(!response.message) {
        this.clients = response;
        this.checkSelectedClient();
      }else {
        console.log(response.message)
        // TODO  create authservice logic for 403 repsone to set user BASE_USER
      }

// TODO


    })
  }

  onSetClient(clientid) {
        // get client info when a client is selected
        this.clientsService.getSelectedClient(clientid)
        .then(response => {
          if (!response.message) {
            const clientarray = response;
            this.client = clientarray[0];
            this.displayButton = false;
            this.getAltAddresses(clientid)
          } else {
            console.log(response.message)
            // TODO  create authservice logic for 403 repsone to set user BASE_USER
          }
        });
  }

  onClientSelected(eventValue){
    // get client info when a client is selected
    this.clientsService.getSelectedClient(eventValue)
    .then(response => {
      if(!response.message) {
        console.log(response)
        const clientarray = response;
        this.client = clientarray[0]
        // set data in local storage for use by components
        localStorage.setItem('selected', this.client.cname),
        localStorage.setItem('selectedId', this.client.clientid)
        this.displayButton = true;
        this.getClientContacts(this.client.clientid);
        this.clientId = this.client.clientid;
        this.clientName = this.client.cname;
        this.getAltAddresses(this.client.clientid);




      } else {
        console.log(response.message)
        // TODO  create authservice logic for 403 repsone to set user BASE_USER
      }

    })
  }
  onNoClient(){
    // case no client is selected fill in empty strings
    this.client = {cname: 'No Client Selected', address: "", city: "", state: "", zip: "", qbid: "0"};
    this.displayButton = false;
  }

  onClearSelected(){// TODO
    // clear localStorage selected and selectedId then route back to selectClient
    localStorage.removeItem('selected');
    localStorage.removeItem('selectedId');
    this.onNoClient();
    this.displayButton = false;
    this.clientContacts = [];
    this.altAddresses = [];
    this.clientName = 'No Client Selected';
    this.router.navigate(['selectclient']);
  }

  checkSelectedClient(){// TODO
    if(localStorage.getItem('selectedId')){
      // if clientid stored rettriev it and use
      const clientid = localStorage.getItem('selectedId');
      // find client info in clientArray
      const clientFiltered = this.clients.filter(function(element) {
        return element.clientid === clientid;
      })
      this.client = clientFiltered[0];
      this.getClientContacts(clientid);

      // this.onClientSelected(clientid);
      this.displayButton = true;

    }else{
      this.onNoClient();
    }
  }

  addCustomer() {
    console.log('add Customer Clicked')
  }

getClientContacts(clientid) {
  this.addressesService.getClientContacts(clientid)
  .then ( (contacts) => {
       // contacts = [{fname: 'None', lname: 'None', phone: 'xxx-xxx-xxxxx' }];
      this.clientContacts = contacts;
  });

}

onAddClientContact(formValue) {
  this.addressesService.addClientContact(this.clientId, formValue)
  .then ( (result) => {
    this.getClientContacts(this.clientId);
    this.addClientContact = false;
  })
}

onPhoneFormat(value) {
  // formaT the phone number on exit
  this.formatPhoneNumber(value, (formatedPhone) => {
    this.phone = formatedPhone;

  } );
}

formatPhoneNumber (str, callback) {
  // Filter only numbers from the input
  const cleaned = ('' + str).replace(/\D/g, '');
  // Check if the input is of correct length
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    callback( '(' + match[1] + ') ' + match[2] + '-' + match[3]);
  }else {
    callback(null)
  }
}

onAddContact() {
  // Toggle addClientContact form open close
  this.addClientContact = this.addClientContact ? false : true;
  this.phone = '';
}

onAltAddressSelected(addressId) {
  // get contacts for the selected address
  this.addressesService.getAddressContacts(addressId)
  .then( (contacts) => {
    this.altContacts = contacts;
    this.altAddressId = addressId;
  });
}

onDragStartContact(event) {
  this.draggingContact = true;
  event.dataTransfer.setData( 'text/plain', event.target.id);
  event.dataTransfer.effectAllowed = 'move';
}

onDropContact(event) {
  //  contact darg and drop event
  this.draggingContact = false;
  const contactid = event.dataTransfer.getData('text/plain')
  this.reOrderContacts(contactid, () => {
    // now loop through client contacts and update each clientcontact
     this.altContacts.forEach( (contact) =>  {
      this.addressesService.updateContact(contact)
      .then( (result) => result );
     });

  });
}


onDragEnterContact(event) {
  event.preventDefault();

}

onDragOverContact(event) {
  event.preventDefault();
}

allowDropContact(event) {
  // console.log(event)
}

reOrderContacts(contactid, callback) {
  // 1slice the array to remove dragged  li by contact id
  let removed;

  for (let i =0 ; i < this.altContacts.length; i++) {
    if (this.altContacts[i].contactid == contactid) {
        removed = this.altContacts.splice(i, 1 );
        // Now change update sortorder setting removed[0] to 0 the rest to 1
        this.altContacts.forEach( (contact) => {
          contact.sortorder = 1;
        });

        removed[0].sortorder = 0;
        this.altContacts.unshift(removed[0]);
        callback();
    }
  }
}

onOpenAddressContactForm() {
  this.openAddressAddForm = (this.openAddressAddForm ? false : true)
}


onNewAltAddress(formValue, formValid) {
  this.openAddressAddForm = false;
  console.log(formValue)
  // logic to post of altAddress get insertId
  this.addressesService.addAddressContact(formValue, this.altAddressId)
  .then ((result) => {
    this.addressesService.getAddressContacts(this.altAddressId)
    .then( (contacts) => {
      this.altContacts = contacts;
    });

    // reload contacts
    // this.addressesService.getAddressContacts(this.altAddressId)
    // .then((altAddresses) => {
    //   console.log(altAddresses)
    //   console.log(result)
    //   this.altAddresses = altAddresses;

    // });
  });
}

}



// WEBPACK FOOTER //
// ./src/app/select-client/select-client.component.ts